import React from "react";
import { Check, X, RotateCcw, Loader2 } from "lucide-react";

export const AuthorityGate = ({ onApprove, onRefuse, onReuse, busy, disabled }) => {
    const base =
        "group relative h-16 px-6 inline-flex items-center justify-between gap-3 rounded-sm border transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
    return (
        <div data-testid="authority-gate" className="border border-slate-200 bg-white rounded-sm p-8 hover-lift">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
                <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                        Acting as
                    </div>
                    <div className="mt-1 font-heading text-xl font-semibold text-slate-900">
                        Prompt Governance Reviewer
                    </div>
                </div>
                <div className="font-mono text-xs text-slate-500 max-w-sm text-right">
                    Authority gate · KATLAS signs the chosen action
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <button
                    data-testid="btn-approve-route"
                    onClick={onApprove}
                    disabled={busy || disabled}
                    className={`${base} bg-slate-900 text-white border-slate-900 hover:bg-slate-800 hover:-translate-y-0.5`}
                >
                    <span className="text-left">
                        <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-slate-300">
                            Primary action
                        </span>
                        <span className="block font-heading text-base font-semibold">
                            Approve bounded prompt route
                        </span>
                    </span>
                    {busy === "approve" ? (
                        <Loader2 className="h-4 w-4 animate-spin shrink-0" />
                    ) : (
                        <Check className="h-5 w-5 shrink-0" />
                    )}
                </button>

                <button
                    data-testid="btn-refuse-route"
                    onClick={onRefuse}
                    disabled={busy || disabled}
                    className={`${base} bg-white text-red-700 border-red-200 hover:bg-red-50 hover:-translate-y-0.5`}
                >
                    <span className="text-left">
                        <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-red-500">
                            Counter-action
                        </span>
                        <span className="block font-heading text-base font-semibold">
                            Refuse / escalate
                        </span>
                    </span>
                    {busy === "refuse" ? (
                        <Loader2 className="h-4 w-4 animate-spin shrink-0" />
                    ) : (
                        <X className="h-5 w-5 shrink-0" />
                    )}
                </button>

                <button
                    data-testid="btn-use-pattern"
                    onClick={onReuse}
                    disabled={busy || disabled}
                    className={`${base} bg-white text-slate-900 border-slate-300 hover:bg-slate-50 hover:-translate-y-0.5`}
                >
                    <span className="text-left">
                        <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                            Reuse · zero new LLM call
                        </span>
                        <span className="block font-heading text-base font-semibold">
                            Use existing approved pattern
                        </span>
                    </span>
                    {busy === "reuse" ? (
                        <Loader2 className="h-4 w-4 animate-spin shrink-0" />
                    ) : (
                        <RotateCcw className="h-5 w-5 shrink-0" />
                    )}
                </button>
            </div>
            {disabled && (
                <p
                    data-testid="authority-disabled-notice"
                    className="mt-5 font-mono text-xs text-amber-700 border border-amber-200 bg-amber-50 rounded-sm px-3 py-2"
                >
                    KATLAS unconfigured — production credential not set. No signed
                    receipt can be produced. No simulation fallback.
                </p>
            )}
        </div>
    );
};

export default AuthorityGate;
